import type { PropsWithChildren, ReactNode } from 'react';

type CouponGridLeftProps = PropsWithChildren;

/**
 * Left side of the CouponGrid.
 *
 * @param root0 input props
 * @param root0.children children to pass down
 * @returns left side of the grid
 */
export default function CouponGridLeft({ children }: CouponGridLeftProps): ReactNode {
  return (
    <div className="bg-container-neutral-on-base-low text-container-neutral-foreground col-span-12 lg:col-span-7">
      {children}
    </div>
  );
}
